export default __webpack_public_path__ + "static/TileMenu_Hover-5a7a7222313654778dc985741c88b397.png";